import apiService from "../../../shared/service/api-service";
import { ATCAppConfig } from "../../../shared/app-configs/atc-app-configs";

export const atcService = {
	async getATCDetails(atcId: string) {
		return await apiService.get(ATCAppConfig.GET_ATC_DETAILS_URL, { atcId });
	},

	async saveATCDetails(data: any) {
		return await apiService.post(ATCAppConfig.POST_ATC_DETAILS_URL, data);
	},


  async uploadFile(
    file: File,
    params: { filename: string; atcNo: string; atcVersionNo: string }
  ) {
    try {
      if (file.type !== 'application/pdf') {
        throw new Error('Only PDF files are allowed');
      }

      // Convert file to raw binary data (ArrayBuffer)
      const fileBuffer = await file.arrayBuffer();
  
      // Construct query string
      const queryString = new URLSearchParams({
        filename: params.filename,
        atcNo: params.atcNo,
        atcVersionNo: params.atcVersionNo,
      }).toString();
  
      const urlWithParams = `${ATCAppConfig.PUT_TC_FILE}?${queryString}`;
  
      // PUT request with raw binary data
      const response = await apiService.put(urlWithParams, fileBuffer, {
        headers: {
          'Content-Type': 'application/pdf',
        },
      });
  
      return response;
    } catch (error) {
      console.error('PDF upload error:', error);
      throw error;
    }
  },
  
	async searchATCLicensingCode(params: {
		atcCbLicensingCode: string;
		coname?: string;
		teid?: string;
		atcStandard?: string;
		uploadType?: string;
		startDate?: string;
		endDate?: string;
		limit?: number;
		offset?: number;
	}) {
		return await apiService.get(ATCAppConfig.GET_ATC_LICENSING_CODE_URL, params);
	},

	async viewFile(params: { filename: string; atcNo: string; atcVersionNo: string }) {
		return await apiService.get(ATCAppConfig.ATC_PREVIEW, params, {
			headers: { Accept: "application/pdf" },
		});
	},

	async deleteATC(atcId: string, atcCbLicensingCode: string) {
		return await apiService.post(ATCAppConfig.ATC_DELETE, { atcId, atcCbLicensingCode });
	},
};
